/**
 * @desc 删除报警规则(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/web/alert/rule/delete',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/mock/web/alert/rule/delete',

    params,
  });
}
